import React, { useEffect, useState } from 'react';
import axios from '../utils/axiosConfig';

interface SmsKayit {
    id: number;
    gonderimTarihi: string;
    gonderilenNumara: string;
    mesaj: string;
    apiHeader: string | null;
    gonderenAdi: string | null;
    basarili: boolean;
    hataMesaji: string | null;
}

interface SmsGecmisiProps {
    cariID?: number;
    leadID?: number;
    /** Dışarıdan trigger: bu değer değişince liste yenilenir */
    refreshKey?: number;
}

const SmsGecmisi: React.FC<SmsGecmisiProps> = ({ cariID, leadID, refreshKey }) => {
    const [liste, setListe] = useState<SmsKayit[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!cariID && !leadID) return;
        fetchListe();
    }, [cariID, leadID, refreshKey]);

    const fetchListe = async () => {
        setLoading(true);
        try {
            const url = cariID
                ? `/api/SmsGonder/cari/${cariID}`
                : `/api/SmsGonder/lead/${leadID}`;
            const res = await axios.get(url);
            setListe(res.data);
        } catch {}
        finally { setLoading(false); }
    };

    const formatTarih = (dt: string) => {
        const d = new Date(dt);
        return d.toLocaleDateString('tr-TR') + ' ' + d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
    };

    if (loading) return (
        <div style={{ textAlign: 'center', padding: 20, color: '#94a3b8', fontSize: 13 }}>
            <i className="fas fa-spinner fa-spin me-2" />Yükleniyor...
        </div>
    );

    if (liste.length === 0) return (
        <div style={{ textAlign: 'center', padding: 24, color: '#94a3b8', fontSize: 13 }}>
            <i className="fas fa-comment-slash" style={{ fontSize: 24, display: 'block', marginBottom: 8 }} />
            Henüz SMS gönderilmemiş.
        </div>
    );

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {liste.map(s => (
                <div key={s.id} style={{
                    border: `1px solid ${s.basarili ? '#bbf7d0' : '#fecaca'}`,
                    borderRadius: 8, padding: '10px 14px',
                    background: s.basarili ? '#f0fdf4' : '#fff5f5'
                }}>
                    {/* Satır 1: Numara + durum + tarih */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, flexWrap: 'wrap' }}>
                        <span style={{
                            display: 'inline-flex', alignItems: 'center', gap: 4,
                            background: s.basarili ? '#dcfce7' : '#fee2e2',
                            color: s.basarili ? '#166534' : '#dc2626',
                            borderRadius: 4, padding: '1px 8px', fontSize: 11, fontWeight: 600
                        }}>
                            <i className={`fas ${s.basarili ? 'fa-check' : 'fa-times'}`} style={{ fontSize: 9 }} />
                            {s.basarili ? 'Gönderildi' : 'Hata'}
                        </span>
                        <span style={{ fontWeight: 600, fontSize: 13, color: '#1e293b' }}>
                            <i className="fas fa-phone" style={{ fontSize: 10, marginRight: 4, color: '#64748b' }} />
                            {s.gonderilenNumara}
                        </span>
                        {s.apiHeader && (
                            <span style={{ fontSize: 11, color: '#64748b', background: '#f1f5f9', borderRadius: 4, padding: '1px 6px' }}>
                                {s.apiHeader}
                            </span>
                        )}
                        <span style={{ marginLeft: 'auto', fontSize: 11, color: '#94a3b8' }}>
                            {formatTarih(s.gonderimTarihi)}
                        </span>
                    </div>
                    {/* Mesaj */}
                    <div style={{ fontSize: 13, color: '#374151', whiteSpace: 'pre-wrap', lineHeight: '1.5' }}>
                        {s.mesaj}
                    </div>
                    {/* Alt: gönderen + hata */}
                    <div style={{ marginTop: 6, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                        {s.gonderenAdi && (
                            <span style={{ fontSize: 11, color: '#94a3b8' }}>
                                <i className="fas fa-user me-1" />{s.gonderenAdi}
                            </span>
                        )}
                        {!s.basarili && s.hataMesaji && (
                            <span style={{ fontSize: 11, color: '#ef4444' }}>
                                <i className="fas fa-exclamation-circle me-1" />{s.hataMesaji}
                            </span>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SmsGecmisi;
